import { useMemo } from "react";
import { LayerAttribute } from "../components/Layer/LayerAttributeItem";

export const useFirstVisibleAttribute = (attributes: LayerAttribute[]): LayerAttribute =>
  useMemo(() => attributes && attributes.filter(({ isDisplayed }) => isDisplayed)[0], [attributes]);
